import React from 'react';

const FooterContent = () => {
  return (
    <div className="footer-content">
      {/* 1. OPIS (LEVO) */}
      <div className="footer-section intro">
        <p>
          Besprekorna čistoća, digitalna sloboda. 
          Pridruži se ClickWash zajednici i održavaj automobil na najsavremeniji način.
        </p>
      </div>
      
      {/* 2. ZAPRATI NAS (SREDINA) */}
      <div className="footer-section social">
        <h4>Zaprati nas</h4>
        <div className="footer-social-icons">
          <a href="https://www.instagram.com/clickwash.rs/" target="_blank" rel="noreferrer" className="social-btn">
            <img src="/images/instagram.png" alt="Instagram" />
          </a>
          <a href="https://www.tiktok.com/@clickwash.rs" target="_blank" rel="noreferrer" className="social-btn">
            <img src="/images/tiktok.png" alt="TikTok" />
          </a>
        </div>
      </div>

      {/* 3. PODRŠKA (DESNO) */}
      <div className="footer-section support">
        <h4>Podrška</h4>
        <div className="footer-contact">
          <p>✉️ office@clickwash.rs</p>
          <p>📍 Beograd, Srbija</p>
        </div>
      </div>
    </div>
  );
};

export default FooterContent;